import { createContext, useContext, useState } from 'react';

type TierResourcesContextType = {
    tiersResources: Set<string>;
    setTiersResources: (tiersResources: Set<string>) => void;
};

const defaultTierResourcesContext: TierResourcesContextType = {
    tiersResources: new Set(),
    setTiersResources: () => {}
};

export const TierResourcesContext = createContext<TierResourcesContextType>(defaultTierResourcesContext);

export const useTierResourcesContext = () => useContext(TierResourcesContext);

export const TierResourcesProvider = ({ children }) => {
    const [tiersResources, setTiersResources] = useState<Set<string>>(new Set());

    return (
        <TierResourcesContext.Provider
            value={{
                tiersResources,
                setTiersResources
            }}>
            {children}
        </TierResourcesContext.Provider>
    );
};
